

















import { Vue, Prop, Component } from "vue-property-decorator";
import Modal from "./Modal.vue";

@Component({
  name: "ContentDeleteModal",
  components: {
    Modal,
  },
})
export default class ContentDeleteModal extends Vue {
  @Prop() contentId: number;
  @Prop() contentType: string;
}
